import { Pipe, PipeTransform } from '@angular/core';
import { StatusLogGeral } from '../../models/logGeral/StatusLogGeral';

@Pipe({
  name: 'statusLogGeral',
})
export class StatusLogGeralPipe implements PipeTransform {
  transform(value: StatusLogGeral): string {
    return {
      [StatusLogGeral.Falha]: 'Falha',
      [StatusLogGeral.Sucesso]: 'Sucesso',
    }[value];
  }
}
